<div mat-dialog-title style="margin: 0;">
    <span>{{v10 ? 'Grade Override Codes': 'Special Mark Codes'}}</span>
</div>

<mat-dialog-content>
    <table>
        <tr>
            <th style="width:150px; padding-left:10px;">
                Code
            </th>
            <th style="width:400px;padding-left:10px;">
                Description
            </th>
        </tr>
        <tr *ngFor="let code of overrideCodes; let i = index"
            [ngClass]="{'tableOddRow': !isEven(i +1), 'tableEvenRow': isEven(i + 1)}">
            <td style="padding-left:10px;">
                {{code.Code}}
            </td>
            <td style="padding-left:10px;">
                {{code.Description}}
            </td>
        </tr>
    </table>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button id="overrideCodeCloseButton" image="cancel.png" label="Close" (clickEvent)="closeClick()">
        </tyl-button>
    </div>
</mat-dialog-actions>